// Angular
import { Component, OnInit } from "@angular/core";
// Models
import { ElasticService } from "./../../services/elastic";

import { Tournament } from "./../../models/tournament";
// Services
import { ApiService } from "./../../services/api";
import * as lodash from "lodash";
import { AngularFireDatabase } from "angularfire2/database";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-club-subscriptions",
  templateUrl: "./club.subscriptions.component.html",
})
export class ClubSubscriptionsComponent implements OnInit {
  public filterargs: Tournament;
  public date: any;
  public currentPage: number;
  public maxPage: number;
  public clubs: Array<any>;

  public query: string;

  public typingDelay: any;
  public pageSize: number;
  public imageLoader: boolean = true;
  public tournaments: Array<Tournament>;

  constructor(
    private elasticService: ElasticService,
    private apiService: ApiService,
    private fireDatabase: AngularFireDatabase,
    private datePipe: DatePipe
  ) {
    this.filterargs = new Tournament();
    this.currentPage = 0;
    this.pageSize = 30;
    this.query = "";
  }

  ngOnInit() {
    this.goToPage(this.currentPage);
  }
  goToPage(index: number) {
    const fromIndex = index * this.pageSize;

    let queryParams = {
      index: "users",
      type: "club",
      size: this.pageSize,
      from: fromIndex,
      "body/query/bool/must/query_string/query": "true",
      "body/query/bool/must/query_string/fields": [`isVerified^10`],
    };

    this.elasticService
      .search(queryParams)
      .then((result) => {
        this.clubs = [];
        lodash.forEach(result["hits"], (item) => {
          var club = item["_source"];
          var daysLeft = 0;
          var status = "";
          var type = "";
          const now = new Date();
          if (club["subscription"]) {
            if (club["subscription"] * 1000 > now.getTime()) {
              daysLeft = Math.round(
                Math.abs(
                  (club["subscription"] * 1000 - now.getTime()) /
                    (24 * 60 * 60 * 1000)
                )
              );
              status = "Running";
              type = "Subscription";
            } else {
              daysLeft = 0;
              status = "Expired";
              type = "Subscription";
            }
            const d = new Date();
            d.setDate(d.getDate() + daysLeft);
            club["subscription"] = `${d.getDate()}-${
              d.getMonth() + 1
            }-${d.getFullYear()}`;
          } else {
            if (club["trial"]) {
              if (club["trial"] * 1000 > now.getTime()) {
                daysLeft = Math.round(
                  Math.abs(
                    (club["trial"] * 1000 - now.getTime()) /
                      (24 * 60 * 60 * 1000)
                  )
                );
                status = "Running";
                type = "Trial Period";
              } else {
                daysLeft = 0;
                status = "Expired";
                type = "Trial Period";
              }
              const d = new Date();
              d.setDate(d.getDate() + daysLeft);
              club["trial"] = `${d.getDate()}-${
                d.getMonth() + 1
              }-${d.getFullYear()}`;
            } else {
              daysLeft = 0;
              status = "Expired";
              type = "Trial Period";
            }
          }
          club.subType = type;
          club.subStatus = status;
          club.subDayleft = daysLeft;
          this.clubs.push(lodash.assign({ $key: item["_id"] }, club));
        });

        window.scrollTo(0, 0);
        this.imageLoader = false;
        this.currentPage = index;
        this.maxPage = Math.ceil(result["total"] / this.pageSize);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  goNext() {
    const index = this.currentPage + 1;
    this.goToPage(index);
  }

  goPrev() {
    const index = this.currentPage - 1;
    this.goToPage(index);
  }

  getIndex(index: number) {
    return this.currentPage * this.pageSize + index + 1;
  }
  changeQuery() {
    clearTimeout(this.typingDelay);

    this.typingDelay = setTimeout(() => {
      this.goToPage(this.currentPage);
    }, 400);
  }
  public dateChange(event) {
    this.filterargs.startDate = this.datePipe.transform(event, "yyyy-MM-dd");
    // console.log(this.filterargs.startDate)
  }
}
